/**
 * The plain secondary line an OAuth account row shows for the identity its grant belongs to (design
 * follow-up 1). There is no readable grant health on an OAuth account — no expiry, no status, and the
 * `secret` object comes back empty — so "whose access is this" is the most useful thing a row can say.
 *
 * Deliberately narrow: `AccountView.oauthIdentity` never carries the provider's raw user id (see its
 * own doc comment), and this function shows nothing at all — never a placeholder or an em dash — when
 * there is no identity to report, which is every key-based account and an OAuth one the platform
 * attached none to.
 */
export interface OauthIdentity {
  displayName?: string;
  email?: string;
}

export function connectedAsLabel(identity: OauthIdentity | undefined): string | null {
  if (identity?.email) return `Connected as ${identity.email}`;
  if (identity?.displayName) return `Connected as ${identity.displayName}`;
  return null;
}
